import {NgModule} from '@angular/core';
import {CommonModule, DecimalPipe, NgIf} from '@angular/common';
import {ClientRoutingModule} from './client-routing.module';
import {TranslateModule} from "@ngx-translate/core";
import {BaseModule} from "../base/base.module";
import {MatStep, MatStepLabel, MatStepper} from "@angular/material/stepper";
import {InfiniteScrollDirective} from 'ngx-infinite-scroll';
import {MatFormField, MatLabel, MatSuffix} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatOption, MatSelect, MatSelectTrigger} from '@angular/material/select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AccountComponent} from './account/account.component';
import {AddressesComponent} from './addresses/addresses.component';
import {BasketComponent} from './basket/basket.component';
import {CheckOutComponent} from './check-out/check-out.component';
import {ClientDashboardComponent} from './client-dashboard/client-dashboard.component';
import {FacilityChooserComponent} from './facility-chooser/facility-chooser.component';
import {FavoriteComponent} from './favorite/favorite.component';
import {FooterClientComponent} from './footer-client/footer-client.component';
import {HeaderClientComponent} from './header-client/header-client.component';
import {MenuComponent} from './menu/menu.component';
import {LandingComponent} from './landing/landing.component';
import {OrdersComponent} from './orders/orders.component';
import {PaymentStatusComponent} from './payment-status/payment-status.component';
import {ProfileComponent} from './profile/profile.component';
import {ServiceComponent} from './service/service.component';
import {ServiceDetailsPageComponent} from './service-details-page/service-details-page.component';
import {DialogModule} from './dialog/dialog.module';
import {MatSidenav, MatSidenavContainer, MatSidenavContent} from "@angular/material/sidenav";
import {MatNavList} from '@angular/material/list';
import {PaymentDetailComponent} from './payment-detail/payment-detail.component';
import {SpaceStringPipe} from "../../util/pipes/space.string";

@NgModule({
  declarations: [
    AccountComponent,
    AddressesComponent,
    BasketComponent,
    CheckOutComponent,
    ClientDashboardComponent,
    FacilityChooserComponent,
    FavoriteComponent,
    FooterClientComponent,
    HeaderClientComponent,
    LandingComponent,
    MenuComponent,
    OrdersComponent,
    PaymentStatusComponent,
    ProfileComponent,
    ServiceComponent,
    ServiceDetailsPageComponent,
    PaymentDetailComponent
  ],
  exports: [
    HeaderClientComponent,
    FooterClientComponent
  ],
  imports: [
    CommonModule,
    ClientRoutingModule,
    DialogModule,
    TranslateModule,
    BaseModule,
    MatStepper,
    MatStep,
    MatStepLabel,
    InfiniteScrollDirective,
    MatFormField,
    MatIcon,
    MatLabel,
    MatSelect,
    MatSelectTrigger,
    MatSuffix,
    ReactiveFormsModule,
    MatOption,
    MatSidenavContainer,
    MatSidenav,
    MatNavList,
    MatSidenavContent,
    FormsModule,
    SpaceStringPipe,
    BaseModule,
    DecimalPipe,
    NgIf
  ]
})
export class ClientModule {
}
